import React from 'react';
import { Link } from 'react-router-dom';
import './AppointmentHeader.css';

const AppointmentHeader = () => {
  return (
    <div className="appointment-header-container">
      <div className="scrolling-text">
        <p>📞 Book your Physiotherapy Consultation now – Call us at +91 8827743823 / +91 7558340139 or click to make an appointment!</p>
      </div>
      <Link to="/appointment" className="appointment-link">Make Appointment</Link>
    </div>
  );
};

export default AppointmentHeader;
